<template>
  <div class="me-mp">
    <div class="header">
      <div class="title">{{ $t("lang.personalInfo") }}</div>
      <el-button class="logout-btn" @click="dialogSliderVisible = true">{{ $t("lang.unbindling") }}</el-button>
    </div>
    <div class="card info-card">
      <div class="avatar">
        <img :src="userinfo.avatarUrl">
      </div>
      <div class="name">{{ userinfo.name }}</div>
      <div class="detail">
        <div class="age">
          <span class="text">{{ $t("lang.age") }}</span>
          <span class="ctx">{{ userinfo.age }}</span>
        </div>
        <div class="country">
          <span class="text">{{ $t("lang.nationality") }}</span>
          <span class="ctx">{{ country }}</span>
        </div>
      </div>
    </div>
    <div class="card intro-card">
      <div class="title">{{ $t("lang.selfIintroduction") }}</div>
      <div class="intro">{{ userinfo.introduction }}</div>
    </div>
    <div class="card video-card">
      <div class="video-header">
        <div class="title">{{ $t("lang.selfIntroductionVideo") }}</div>
        <el-upload
          class="upload-demo pull-right"
          action=""
          name="videoFile"
          :show-file-list="false"
          :http-request="handleUploadVideo"
          :multiple="false"
          :on-success="handleUploadVideoScucess"
          :before-upload="beforeUploadVideo"
          v-if="!isVideoUpload"
        >
          <el-button class="upload-btn">{{ $t("lang.change") }}</el-button>
        </el-upload>
        <div class="upload-status" v-else>
          <div class="upload-progress" v-if="progressVal > 0">
            <div
              class="upload-progress-bar"
              :style="{ width: progressVal + '%' }"
            ></div>
          </div>
          <span class="upload-status-text" v-if="progressVal > 0"
            >{{ progressVal }}%</span
          >
          <span class="upload-status-text" v-else>Waiting for upload</span>
        </div>
      </div>
      <div v-if="userinfo.introVideoUrl" class="intro-video">
        <video :src="userinfo.introVideoUrl" controls></video>
      </div>
    </div>
    <div class="footer">
      <p class="text">{{ $t("lang.cooperationTip1") }}<br>{{ $t("lang.cooperationTip2") }}</p>
    </div>
    <el-dialog
      class="unbinding-dialog"
      :show-close="false"
      :center="true"
      :width="'86vw'"
      :top="'25vh'"
      :visible.sync="dialogSliderVisible"
    >
      <div class="tip">{{ $t("lang.unbindlingTip") }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="quit-btn" @click="dialogSliderVisible = false">{{ $t("lang.cancel") }}</el-button>
        <el-button class="unbinding-btn" @click="handleUnBindUser">{{ $t("lang.unbind") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ERR_OK } from "api/config";
import { unBindUser } from '@/api/login.js'
import { updateUserInfo } from "api/me";
import crypto from "crypto";

export default {
  data () {
    return {
      userinfo: {
        id: "",
        introVideoUrl: "",
        videoCdn: "",
        introduction: ""
      },
      isVideoUpload: false,
      videoUrl: "",
      progressVal: 0,
      dialogSliderVisible: false,
      baseUrl: window.location.href.split('?code')[0]
    }
  },
  computed: {
    country() {
      if (this.userinfo.nationality === 'China') {
        return '中国'
      } else {
        return this.userinfo.nationality
      }
    }
  },
  created () {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      this.$store
        .dispatch("GetUserInfo")
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.userinfo = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(() => {});
    },
    handleUnBindUser() {
      unBindUser({
        loginType: 'WECHAT_GZH'
      }).then(response => {
        if (response.status === 200) {
          if (response.data !== "" && response.data.code === 200) {
            // this.btnLoading = false;
            this.dialogSliderVisible = false
            this.$store.dispatch("FedLogOut")
              .then(() => {
                if (this.baseUrl) {
                  window.location.href = this.baseUrl + '#/m/login'
                } else {
                  this.$router.push({ path: "/m/login" });
                }
              })
              .catch(() => {});
          } else {
            // this.btnLoading = false;
            this.dialogSliderVisible = false
            this.$message.error(response.data.message);
          }
        } else {
          // this.btnLoading = false;
          this.dialogSliderVisible = false
          this.$message.error(this.$t('lang.loginPage23'));
        }
      })
      .catch(error => {
        if (error.toString().includes(400)) {
          this.dialogSliderVisible = false
          this.$message.error(this.$t('lang.loginPage24'));
        } else {
          this.$message.error(this.$t('lang.loginPage23'));
        }
        this.dialogSliderVisible = false
        // this.btnLoading = false;
      });
    },
    beforeUploadVideo(file) {
      let fileType = true;
      if (["video/mp4"].indexOf(file.type) === -1) {
        this.$message.error(this.$t("lang.userPage78"));
        fileType = false;
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error(this.$t("lang.userPage79"));
        return false;
      }
      this.isVideoUpload = true;
      return isLt2M && fileType;
    },
    handleUploadVideo(e) {
      var filename = "";
      var buf = crypto.randomBytes(16);
      for (var i = 0; i < buf.length; ++i) {
        filename += ("0" + buf[i].toString(16)).slice(-2);
      }
      filename +=
        Math.random()
          .toString()
          .slice(2, 10) + ".mp4";
      var geolocation = new window.BMap.Geolocation();
      var self = this;
      var client;
      geolocation.getCurrentPosition(function(r) {
        if (geolocation.getStatus() === window.BMAP_STATUS_SUCCESS) {
          if (/^[\u4e00-\u9fa5]+$/.test(r.address.province)) {
            client = new window.OSS.Wrapper({
              region: "oss-cn-beijing",
              accessKeyId: "LTAIoBoyRxdEVtf9",
              accessKeySecret: "Wuq0DTuMpGPe1nCFsjpamhYzMSi4XJ",
              bucket: "bingotalk-bj",
              secure: true
            });

            client
              .multipartUpload("video/" + filename, e.file, {
                progress: function(p) {
                  return function(done) {
                    self.progressVal = parseInt(p * 100);
                    e.onProgress({ percent: p * 100 });
                    done();
                  };
                }
              })
              .then(function(result) {
                self.videoUrl = filename;
                self.userinfo.videoCdn = "https://bj.static.bingotalk.cn";
                e.onSuccess(result);
              })
              .catch(function(err) {
                e.onError(err);
              });
          } else {
            client = new window.OSS.Wrapper({
              region: "oss-us-west-1",
              accessKeyId: "LTAIoBoyRxdEVtf9",
              accessKeySecret: "Wuq0DTuMpGPe1nCFsjpamhYzMSi4XJ",
              bucket: "bingotalk-sv",
              secure: true
            });

            client
              .multipartUpload("video/" + filename, e.file, {
                progress: function(p) {
                  return function(done) {
                    self.progressVal = parseInt(p * 100);
                    e.onProgress({ percent: p * 100 });
                    done();
                  };
                }
              })
              .then(function(result) {
                self.videoUrl = filename;
                self.userinfo.videoCdn = "https://sv.static.bingotalk.cn";
                e.onSuccess(result);
              })
              .catch(function(err) {
                e.onError(err);
              });
          }
        } else {
          client = new window.OSS.Wrapper({
            region: "oss-us-west-1",
            accessKeyId: "LTAIoBoyRxdEVtf9",
            accessKeySecret: "Wuq0DTuMpGPe1nCFsjpamhYzMSi4XJ",
            bucket: "bingotalk-sv",
            secure: true
          });

          client
            .multipartUpload("video/" + filename, e.file, {
              progress: function(p) {
                return function(done) {
                  self.progressVal = parseInt(p * 100);
                  e.onProgress({ percent: p * 100 });
                  done();
                };
              }
            })
            .then(function(result) {
              self.videoUrl = filename;
              self.userinfo.videoCdn = "https://sv.static.bingotalk.cn";
              e.onSuccess(result);
            })
            .catch(function(err) {
              e.onError(err);
            });
        }
      });
    },
    handleUploadVideoScucess(response, file, fileList) {
      this.userinfo.introVideoUrl = this.videoUrl;
      this._updateVideoInfo();
    },
    _updateVideoInfo() {
      let updateVideoInfo = {
        id: this.userinfo.id,
        videoCdn: this.userinfo.videoCdn,
        introVideoUrl: this.userinfo.introVideoUrl
      };
      updateUserInfo(updateVideoInfo)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.progressVal = 0;
              this.isVideoUpload = false;
              this.$message.success(this.$t("lang.userPage77"));
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    }
  }
}
</script>

<style lang="scss">
.me-mp {
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 750px;
  padding: 0 4vw;
  height: 100vh;
  margin: 0 auto;
  font-size: 20px;
  background: #f9f9f9;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0;

    .title {
      font-size: 14px;
      font-weight: 500;
    }

    .logout-btn {
      border: none;
      padding: 6px;
      background: none;
      font-size: 14px;
      color: #F5A623;
    }
  }

  .card {
    // display: flex;
    // flex-direction: column;
    margin-bottom: 10px;
    padding: 10px;
    font-size: 16px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
  }

  .info-card {
    .avatar {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 60px;
      margin: 10px auto;
      border-radius: 50%;
      overflow: hidden;

      img {
        height: 100%;
      }
    }

    .name {
      margin: 10px auto 18px;
      font-size: 16px;
      text-align: center;
      font-weight: 500;
    }

    .detail {
      display: flex;
      justify-content: space-around;
      width: 100%;
      margin-bottom: 17px;

      .text {
        font-size: 14px;
        color: #9B9B9B;
      }

      .ctx {
        font-size: 14px;
        color: #4A4A4A;
      }
    }
  }

  .intro-card {
    .title {
      margin-bottom: 18px;
      font-size: 15px;
      color: #4A4A4A;
    }

    .intro {
      font-size: 15px;
      color: #4A4A4A;
    }
  }

  .video-card {
    padding-bottom: 40px;
    margin-bottom: 40px;

    .video-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 22px;

      .title {
        font-size: 14px;
        font-weight: 500;
        color: #4A4A4A;
      }

      .upload-btn {
        border: none;
        padding: 6px;
        background: none;
        font-size: 14px;
        color: #F5A623;
      }  
    }
    .intro-video {
      video {
        width: 100%;
      }
    }
  }
  
  .footer {
    position: fixed;
    z-index: 10;
    left: 0;
    bottom: 0;
    z-index: 10;
    width: 100vw;
    height: 50px;
    background: rgba(237, 109, 89, 0.2);
    color: #ED6D59;
    font-size: 10px;
    text-align: center;
  }

  .unbinding-dialog {
    .el-dialog {
      border-radius: 12px;
      background: #ffffff;
    }

    .el-dialog__header {
      padding: 20px 0 0;
    }

    .el-dialog__body {
      .tip {
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #4A4A4A;
      }
    }

    .quit-btn,
    .unbinding-btn {
      border-radius: 0;
      width: 110px;
      height: 46px;
      border: none;
      border-radius: 5px;
      outline: none;
      color: #4A4A4A;
      background-color: #E4E7ED;
    }

    .unbinding-btn {
      border-radius: 5px;
      background: #FFE300;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/h5/me-mp.vue